export const GRAPHIC_STYLE = "gs";

export const GALLERY = "gallery";
export const GALLERY_IMAGE_BORDER = `${GALLERY}.imgBorder`;
export const GALLERY_FULL_SCREEN = `${GALLERY}.fs`;

export const BACKGROUND_FILL_TYPE = "bgFillType";
export const BACKGROUND_COLOR = "bgColor";
export const BACKGROUND_MEDIA_TYPE = "bgMediaType";
export const BACKGROUND_IMAGE_OPACITY = "bgOpacity";
export const BACKGROUND_IMAGE_POSITION = "bgPos";
export const BACKGROUND_IMAGE_SCALE = "bgScale";
export const BACKGROUND_IMAGE_SCROLL = "bgScroll";
export const BACKGROUND_MEDIA_IMAGE = "bgImage";
export const BACKGROUND_MEDIA_VIDEO = "bgVideo";
export const BACKGROUND_VIDEO_LOOP = "bgLoop";
export const BACKGROUND_GRADIENT_COLOR_1 = "bgGc1";
export const BACKGROUND_GRADIENT_COLOR_2 = "bgGc2";
export const BACKGROUND_GRADIENT_ROTATION = "bgGr";

export const BORDER_WIDTH = "bW";
export const BORDER_COLOR = "bC";
export const BORDER_STYLE = "bS";

/** Element generic */
export const ELEMENT_BACKGROUND_COLOR = "bgcolor";
export const ELEMENT_BACKGROUND_FILL_TYPE = "fillType";
export const GRADIENT_COLOR_1 = "gc1";
export const GRADIENT_COLOR_2 = "gc2";
export const GRADIENT_ROTATION = "gr";
export const BLUR = "blur";
export const BACKDROP_FILTER = "backdropFilter";

/** shadow */
export const SHADOW = "shadow";
export const SHADOW_STYLE = "shadow.style";
export const SHADOW_COLOR = "shadow.sc";
export const SHADOW_OFFSET_X = "shadow.sx";
export const SHADOW_OFFSET_Y = "shadow.sy";
export const SHADOW_BLUR = "shadow.sb";

/** border */
export const BORDER = "border";
export const BORDER_RADIUS = `${BORDER}.rad`;
export const OPACITY = "o";

/** hover specific */
export const HOVER = "hover";

export const HOVER_OPACITY = `${HOVER}.${OPACITY}`;
export const HOVER_SHADOW_ROOT = `${HOVER}.shadow`;
export const HOVER_SHADOW_STYLE = `${HOVER}.${SHADOW_STYLE}`;
export const HOVER_SHADOW_COLOR = `${HOVER}.${SHADOW_COLOR}`;
export const HOVER_SHADOW_OFFSET_X = `${HOVER}.${SHADOW_OFFSET_X}`;
export const HOVER_SHADOW_OFFSET_Y = `${HOVER}.${SHADOW_OFFSET_Y}`;
export const HOVER_SHADOW_BLUR = `${HOVER}.${SHADOW_BLUR}`;
export const HOVER_BLUR = `${HOVER}.${BLUR}`;

export const GALLERY_AUTO_ADVANCE_TIME = `${GALLERY}.aa`;
export const GALLERY_TRANSITION = `${GALLERY}.tran`;
export const GALLERY_TRANSITION_DURATION = `${GALLERY}.tranTime`;
export const GALLERY_COLUMNS = `${GALLERY}.cols`;
export const GALLERY_ENFORCE_ORDER = `${GALLERY}.enforceOrder`;
export const GALLERY_IMAGE_PADDING = `${GALLERY}.imgPad`;

/** tile specific */
export const GALLERY_IMAGE_BORDER_WIDTH = `${GALLERY_IMAGE_BORDER}.w`;
export const GALLERY_IMAGE_BORDER_COLOR = `${GALLERY_IMAGE_BORDER}.c`;
export const GALLERY_IMAGE_BORDER_RADIUS = `${GALLERY_IMAGE_BORDER}.rad`;

export const GALLERY_FULL_SCREEN_BACKGROUND_COLOR = `${GALLERY_FULL_SCREEN}.bgc`;
export const GALLERY_FULL_SCREEN_CONTROL_COLOR = `${GALLERY_FULL_SCREEN}.cc`;

/** slide specific */
export const SLIDING_GALLERY_CONFIG = "content.config";
export const SLIDING_GALLERY_TYPE = "content.config.type";
export const GALLERY_DOTS = `${GALLERY}.dots`;
export const GALLERY_INACTIVE_IMAGES = `${GALLERY}.imgInactive`;

// why lower case??
export const GALLERY_NO_LOOP = `${GALLERY}.noloop`;

export const GALLERY_DOTS_COLOR = `${GALLERY_DOTS}.c`;
export const GALLERY_DOTS_SELECTED_COLOR = `${GALLERY_DOTS}.ac`;
export const GALLERY_DOTS_LOCATION = `${GALLERY_DOTS}.loc`;
export const GALLERY_DOTS_SIZE = `${GALLERY_DOTS}.size`;
export const GALLERY_DOTS_GAP = `${GALLERY_DOTS}.gap`;
export const GALLERY_DOTS_OFFSET = `${GALLERY_DOTS}.offset`;

export const GALLERY_INACTIVE_IMAGES_OPACITY = `${GALLERY_INACTIVE_IMAGES}.o`;
export const GALLERY_INACTIVE_IMAGES_BLUR = `${GALLERY_INACTIVE_IMAGES}.blur`;
export const GALLERY_INACTIVE_IMAGES_SCALE = `${GALLERY_INACTIVE_IMAGES}.scale`;
// this is nested in the menu but stored separately?
export const GALLERY_INACTIVE_IMAGES_PRELOAD = `${GALLERY}.preload`;

export const GRAPHIC_STYLE_TYPE = `${GRAPHIC_STYLE}.t`;
export const GRAPHIC_STYLE_OFFSET_X = `${GRAPHIC_STYLE}.x`;
export const GRAPHIC_STYLE_OFFSET_Y = `${GRAPHIC_STYLE}.y`;
export const GRAPHIC_STYLE_HORIZONTAL_SHIFT = `${GRAPHIC_STYLE}.s`;
export const GRAPHIC_STYLE_SCALE_PERCENTAGE = `${GRAPHIC_STYLE}.p`;

// todo: consolidate this to element props
export const RECTANGLE_FILL_TYPE = ELEMENT_BACKGROUND_FILL_TYPE;
export const RECTANGLE_BACKGROUND_COLOR = ELEMENT_BACKGROUND_COLOR;
export const RECTANGLE_GRADIENT_COLOR_1 = GRADIENT_COLOR_1;
export const RECTANGLE_GRADIENT_COLOR_2 = GRADIENT_COLOR_2;
export const RECTANGLE_GRADIENT_ROTATION = GRADIENT_ROTATION;

export const ICON_COLOR = "c";

export const PADDING = "padding";
export const RECTANGLE_PADDING_X = "padX";
export const RECTANGLE_PADDING_Y = "padY";

/** text/design styles */
export const TEXT_STYLES = "styles";
export const TEXT_LINK = "link";

export const TEXT_STYLES_LINK = `${TEXT_STYLES}.${TEXT_LINK}`;

export const TEXT_STYLE = "style";
export const TEXT_COLOR = "c";
export const TEXT_FONT = "font";
export const TEXT_FONTS = "fonts";
export const TEXT_SIZE = "size";
export const TEXT_LINE_HEIGHT = "lH";
export const TEXT_LETTER_SPACING = "lS";
export const TEXT_LETTER_CASE = "lC";
export const TEXT_ALIGNMENT = "tA";
export const TEXT_COLUMNS = "columnCnt";
export const TEXT_COLUMNS_GAP = "columnGap";
export const TEXT_MARGIN_BOTTOM = "mB";
export const TEXT_OVERFLOW = "over";

export const TEXT_FORMAT = "tD";
export const TEXT_HOVER_COLOR = "hC";
export const TEXT_HOVER_FORMAT = "hTd";

export const TEXT_LINK_COLOR = `${TEXT_LINK}.c`;
export const TEXT_LINK_FORMAT = `${TEXT_LINK}.tD`;
export const TEXT_LINK_HOVER_COLOR = `${TEXT_LINK}.hC`;
export const TEXT_LINK_HOVER_FORMAT = `${TEXT_LINK}.hTd`;

export const TEXT_STYLES_LINK_COLOR = `${TEXT_STYLES}.${TEXT_LINK_COLOR}`;
export const TEXT_STYLES_LINK_FORMAT = `${TEXT_STYLES}.${TEXT_LINK_FORMAT}`;
export const TEXT_STYLES_LINK_HOVER_COLOR = `${TEXT_STYLES}.${TEXT_LINK_HOVER_COLOR}`;
export const TEXT_STYLES_LINK_HOVER_FORMAT = `${TEXT_STYLES}.${TEXT_LINK_HOVER_FORMAT}`;

/** social grid */
export const SOCIAL_GRID_ALIGNMENT = "alignment";
export const SOCIAL_GRID_AUTO_GAP = "autoGap";
export const SOCIAL_GRID_GAP = "gap";
export const SOCIAL_GRID_OVERFLOW = "overflow";
export const SOCIAL_GRID_ROWS = "rows";

/** line */
export const LINE_STYLE = "lineStyle";
export const LINE_COLOR = "c";
export const LINE_THICKNESS = "h";
export const LINE_END_CAP = "lineCap";
export const LINE_DASH_WIDTH = "dW";
export const LINE_DASH_SPACING = "dF";

/** embed */
export const IFRAME_SCALE = "if.s";

/** animation */
export const ANIMATION_TYPE = "type";
export const ANIMATION_DURATION = "duration";
export const ANIMATION_DELAY = "delay";
export const ANIMATION_DIRECTION = "direction";

/** animation values */
export const TRANSITION_TYPE_NONE = "none";
export const TRANSITION_TYPE_FADE = "fade";
export const TRANSITION_TYPE_SLIDE = "slide";
export const TRANSITION_TYPE_BOUNCE = "bounce";
export const TRANSITION_TYPE_ROTATE = "rotate";
export const TRANSITION_TYPE_ZOOM = "zoom";
export const TRANSITION_TYPE_FLIP = "flip";
export const TRANSITION_TYPE_ROLL = "roll";
export const TRANSITION_TYPE_LIGHT_SPEED = "lightSpeed";

/** button values */
export const BUTTON_STYLES = "styles";
export const BUTTON_STYLE = "style";

export const BUTTON_PADDING = "padding";
export const BUTTON_HEIGHT = "height";
export const BUTTON_WIDTH = "width";

export const BUTTON_BORDER = "border";
// export const BUTTON_RADIUS = "rad";
export const BUTTON_BORDER_COLOR = BORDER_COLOR;
export const BUTTON_BORDER_WIDTH = BORDER_WIDTH;
export const BUTTON_BORDER_STYLE = BORDER_STYLE;
export const BUTTON_BORDER_RADIUS = BORDER_RADIUS;

// todo: consolidate this to element props
export const BUTTON_FILL_TYPE = ELEMENT_BACKGROUND_FILL_TYPE;
export const BUTTON_BACKGROUND_COLOR = ELEMENT_BACKGROUND_COLOR;
export const BUTTON_GRADIENT_COLOR_1 = GRADIENT_COLOR_1;
export const BUTTON_GRADIENT_COLOR_2 = GRADIENT_COLOR_2;
export const BUTTON_GRADIENT_ROTATION = GRADIENT_ROTATION;

export const BUTTON_TEXT_PREFIX = "text";

export const BUTTON_TEXT_COLOR = `${BUTTON_TEXT_PREFIX}.${TEXT_COLOR}`;
export const BUTTON_TEXT_FONT = `${BUTTON_TEXT_PREFIX}.${TEXT_FONT}`;
export const BUTTON_TEXT_SIZE = `${BUTTON_TEXT_PREFIX}.${TEXT_SIZE}`;
export const BUTTON_TEXT_LETTER_SPACING = `${BUTTON_TEXT_PREFIX}.${TEXT_LETTER_SPACING}`;
export const BUTTON_TEXT_LINE_HEIGHT = `${BUTTON_TEXT_PREFIX}.${TEXT_LINE_HEIGHT}`;
export const BUTTON_TEXT_LETTER_CASE = `${BUTTON_TEXT_PREFIX}.${TEXT_LETTER_CASE}`;
export const BUTTON_TEXT_ALIGNMENT = `${BUTTON_TEXT_PREFIX}.${TEXT_ALIGNMENT}`;
export const BUTTON_TEXT_COLUMNS = `${BUTTON_TEXT_PREFIX}.${TEXT_COLUMNS}`;
export const BUTTON_TEXT_COLUMNS_GAP = `${BUTTON_TEXT_PREFIX}.${TEXT_COLUMNS_GAP}`;
export const BUTTON_TEXT_MARGIN_BOTTOM = `${BUTTON_TEXT_PREFIX}.${TEXT_MARGIN_BOTTOM}`;
export const BUTTON_TEXT_OVERFLOW = `${BUTTON_TEXT_PREFIX}.${TEXT_OVERFLOW}`;

// not sure if I need this
export const BUTTON_HOVER_FILL_TYPE = `${HOVER}.${BUTTON_FILL_TYPE}`;

export const BUTTON_HOVER_BACKGROUND_COLOR = `${HOVER}.${BUTTON_BACKGROUND_COLOR}`;
export const BUTTON_HOVER_GRADIENT_COLOR_1 = `${HOVER}.${RECTANGLE_GRADIENT_COLOR_1}`;
export const BUTTON_HOVER_GRADIENT_COLOR_2 = `${HOVER}.${RECTANGLE_GRADIENT_COLOR_2}`;
export const BUTTON_HOVER_GRADIENT_ROTATION = `${HOVER}.${RECTANGLE_GRADIENT_ROTATION}`;

// todo: revert when we swap names
// export const BUTTON_HOVER_DURATION = `${HOVER}.duration`;
export const BUTTON_HOVER_DURATION = `${HOVER}.dur`;
export const BUTTON_HOVER_BORDER_COLOR = `${HOVER}.${BUTTON_BORDER_COLOR}`;
export const BUTTON_HOVER_BORDER_WIDTH = `${HOVER}.${BUTTON_BORDER_WIDTH}`;
export const BUTTON_HOVER_BORDER_RADIUS = `${HOVER}.${BUTTON_BORDER_RADIUS}`;
export const BUTTON_HOVER_PADDING = `${HOVER}.${BUTTON_PADDING}`;

export const BUTTON_HOVER_TEXT_COLOR = `${HOVER}.${BUTTON_TEXT_COLOR}`;
export const BUTTON_HOVER_TEXT_FONT = `${HOVER}.${BUTTON_TEXT_FONT}`;
export const BUTTON_HOVER_TEXT_SIZE = `${HOVER}.${BUTTON_TEXT_SIZE}`;
export const BUTTON_HOVER_TEXT_LETTER_SPACING = `${HOVER}.${BUTTON_TEXT_LETTER_SPACING}`;
export const BUTTON_HOVER_TEXT_LINE_HEIGHT = `${HOVER}.${BUTTON_TEXT_LINE_HEIGHT}`;
export const BUTTON_HOVER_TEXT_LETTER_CASE = `${HOVER}.${BUTTON_TEXT_LETTER_CASE}`;
export const BUTTON_HOVER_TEXT_ALIGNMENT = `${HOVER}.${BUTTON_TEXT_ALIGNMENT}`;
export const BUTTON_HOVER_TEXT_COLUMNS = `${HOVER}.${BUTTON_TEXT_COLUMNS}`;
export const BUTTON_HOVER_TEXT_COLUMNS_GAP = `${HOVER}.${BUTTON_TEXT_COLUMNS_GAP}`;
export const BUTTON_HOVER_TEXT_MARGIN_BOTTOM = `${HOVER}.${BUTTON_TEXT_MARGIN_BOTTOM}`;
export const BUTTON_HOVER_TEXT_OVERFLOW = `${HOVER}.${BUTTON_TEXT_OVERFLOW}`;

/** generic */
export const ENTITY_TYPE = "type";
